import React from 'react';
import PageBody from "Common/Custom/PageBody";
import { HeadingOne } from "Common/Custom/HeadingOne";
import AboutUsTable from './Components/AboutUsTable';

const AboutUsList = () => {

  return (
    <PageBody
      card={true}
      headerchildren={
        <>
          <HeadingOne>About Us Entries</HeadingOne>
        </>
      }
    >
      <div className="col-12"><AboutUsTable /></div>
    </PageBody>
  );
};

export default AboutUsList;